import type { WorkArrangement } from 'src/graphql/generated';

export const workArrangmentDescription = (input: WorkArrangement) => {
  const mapper = {
    ONSITE: 'On-site',
    HYBRID: 'Hybrid',
    REMOTE: 'Remote',
  };
  return mapper[input];
};
